import React from "react";
import { useInstantSearch } from "react-instantsearch";
import CompanySkeletonPage from "./company_skeleton_page";

function SearchLoadingCards() {
  const { results } = useInstantSearch();

  const isLoading = !results;

  if (!isLoading) return null;

  return <CompanySkeletonPage numberOfCards={12} />;
}

export default SearchLoadingCards;
